import { render, staticRenderFns } from "./Sparkpost.vue?vue&type=template&id=34f40c25&scoped=true"
import script from "./Sparkpost.vue?vue&type=script&lang=js"
export * from "./Sparkpost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f40c25",
  null
  
)

export default component.exports